"use strict";

var BaseCollection = require('./baseCollection');
var Call = require('./call');

module.exports = BaseCollection.extend({
    type: 'calls',
    model: Call
});


//////////////////
// WEBPACK FOOTER
// ./models/calls.js
// module id = 792
// module chunks = 2